export const Endpoints = {
  PROCEDURE_TYPES: '/procedure-types',
  LOCAL_AUTHORITIES: '/local-authorities',
  LICENCE_TYPES: '/licence-types',
  LICENCES: '/licences',
  ORGANISATIONS: '/organisations'
}